export default __webpack_public_path__ + "static/media/nhb-footer-logo.42027ae9.svg";